/*
  class Combobox

  jQuery UI の Autocomplete ウィジェットを用いた、カスタム・ウィジェット "combobox" を実装するモジュールです。

  既存の <select> に適用します。
  適用された <select> は、入力フィールド <input> とボタンの組み合わせに置き換えられ、
  入力フィールドは、元の <select> の選択肢となる <option> のリストがソースとなった Autocomplete の機能が働きます。
  またボタンは、元の <option> のリストを表示させる機能が働き、ユーザによる項目の選択によって、
  その値が入力フィールドに設定されるようになります。

  使い方：

    $("select").combobox(options);

  オプション：

    options はプレーンな Object で、有効なキーと値は次のとおりです。

    - uiComboboxShowAllItems
      combobox に使われるすべての項目を表示させるボタンの、説明文。
      これはそのボタンのマウスオーバー時に表示されます。

    - uiComboboxNotMatch
      選択肢にない値をユーザが入力したときに表示するツールチップの内容。
      文字列中に ${value} を置くと、その位置にはユーザが入力した内容が代入されます。

    - uiComboboxNotMatchDelayTime
      選択肢にない値をユーザが入力したときに表示するツールチップが自動で消えるまでの秒数。

    - uiComboboxAdditionalClasses
      combobox に使われる <input> にはいくつかの jQuery-UI 由来の CSS クラス名が設定されますが、
      さらに追加する CSS クラス名。サイト固有のクラス名があればこれに足してください。

    - select
      メニュー項目を選択したときにトリガーされるイベント "select" をハンドルするコールバックを登録できます。

    また、対象の要素の属性値 "data-key" （key は上述のキー）が設定されていれば、
    そちらが優先的に適用されます。
    例）オプション "uiComboboxAdditionalClasses" の設定を、要素上で行う場合：

      <select data-ui-combobox-additional-classes="foo bar">

  */
require("jquery-ui/ui/widgets/autocomplete");
require("jquery-ui/ui/widgets/tooltip");
require("jquery-ui/ui/widgets/button");
require.context('jquery-ui/dist/themes/base/images', true);
require("jquery-ui/dist/themes/base/jquery-ui.css");
require("./jquery-ui.combobox.css");

class Combobox {
  constructor() {
    if (!$.fn.combobox) {
      this._setup();
    }
  }

  _setup() {
    // jQuery-ui 公式ページにある Autocomplete ウィジェットをカスタムした "combobox" のサンプルを、
    // ほぼそのまま記述しています。
    // https://jqueryui.com/autocomplete/#combobox
    $.widget('custom.combobox', {
      // デフォルトのオプションを定義します。
      // widget 呼び出し時に指定可能なオプションで上書きされます。
      // 各メソッド内では this.options で参照できます。
      options: {
        uiComboboxShowAllItems: "Show All Items",
        uiComboboxNotMatch: "${value} didn't match any item",
        uiComboboxNotMatchDelayTime: 2500,
        uiComboboxAdditionalClasses: [],
        // 内部からトリガーされるイベント "select" を処理します。
        select: function(event, ui) {
          console.log('select', event, ui);
        }
      },
      // 要素に data-key があればその値、なければ options.key の値を返します。
      getSettingValue: function(key) {
        let val = $(this.element).data(key);
        if (!val) {
          val = this.options[key]
        }
        return val;
      },
      // widget の初期処理
      _create: function() {
        this.wrapper = $('<span>')
          .addClass('custom-combobox')
          .insertAfter(this.element);

        this.element.hide();
        this._createAutocomplete();
        this._createShowAllButton();
      },
      // _init: function() {
      //   var options = this.options;
      //   console.log("_init", options);
      // },
      _createAutocomplete: function() {
        var selected = this.element.children(':selected'),
          value = selected.val() ? selected.text() : '';

        this.input = $('<input>')
          .appendTo(this.wrapper)
          .val(value)
          .attr('title', '')
          .addClass("custom-combobox-input ui-widget ui-widget-content ui-corner-left")
          .autocomplete({
            delay: 0,
            minLength: 0,
            source: this._source.bind(this)
          })
          .tooltip({
            classes: {
              'ui-tooltip': 'ui-state-highlight'
            }
          });

        this.input.attr('placeholder', $(this.element).data('placeholder'));

        Array(this.getSettingValue('uiComboboxAdditionalClasses') || []).flat().forEach(function(item) {
          this.addClass(item);
        }.bind(this.input));

        this._on(this.input, {
          autocompleteselect: function(event, ui) {
            ui.item.option.selected = true;
            this._trigger('select', event, {
              item: ui.item.option
            });
          },

          autocompletechange: '_removeIfInvalid'
        });
      },
      _createShowAllButton: function() {
        var input = this.input,
          wasOpen = false;

        $('<a>')
          .attr('tabIndex', -1)
          .attr('title', this.getSettingValue('uiComboboxShowAllItems'))
          .tooltip()
          .appendTo(this.wrapper)
          .button({
            icons: {
              primary: 'ui-icon-triangle-1-s'
            },
            text: false
          })
          .removeClass('ui-corner-all')
          .addClass('custom-combobox-toggle ui-corner-right')
          .on('mousedown', function() {
            wasOpen = input.autocomplete('widget').is(':visible');
          })
          .on('click', function() {
            input.trigger('focus');

            // Close if already visible
            if (wasOpen) {
              return;
            }

            // Pass empty string as value to search for, displaying all results
            input.autocomplete('search', '');
          });
      },
      _source: function(request, response) {
        var matcher = new RegExp($.ui.autocomplete.escapeRegex(request.term), 'i');
        response(this.element.children('option').map(function() {
          var text = $(this).text();
          if (this.value && (!request.term || matcher.test(text)))
            return {
              label: text,
              value: text,
              option: this
            };
        }));
      },
      _removeIfInvalid: function(event, ui) {
        // Selected an item, nothing to do
        if (ui.item) {
          return;
        }

        // Search for a match (case-insensitive)
        var value = this.input.val(),
          valueLowerCase = value.toLowerCase(),
          valid = false;
        this.element.children('option').each(function() {
          if ($( this ).text().toLowerCase() === valueLowerCase) {
            this.selected = valid = true;
            return false;
          }
        });

        // Found a match, nothing to do
        if (valid) {
          return;
        }

        // Remove invalid value
        this.input
          .val('')
          .attr('title', (this.getSettingValue('uiComboboxNotMatch').replace('${value}', value)))
          .tooltip('open');
        this.element.val('');
        this._delay(function() {
          this.input.tooltip('close').attr('title','');
        }, this.getSettingValue('uiComboboxNotMatchDelayTime'));
        this.input.autocomplete('instance').term = '';
      },
      _destroy: function() {
        this.wrapper.remove();
        this.element.show();
      }
    });
  }
}

const combobox = new Combobox();

export default { combobox }
